import { Box, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FunctionComponent } from 'react';
import EmailVerificationContainer from '../../../email-verification/containers/EmailVerificationContainer';

const useStyles = makeStyles()((theme: Theme) => ({
  content: {
    flexGrow: 1,
    marginTop: theme.spacing(10),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
}));

const EmailVerificationPage: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.content}>
      <EmailVerificationContainer />
    </Box>
  );
};

export default EmailVerificationPage;
